module.exports = __webpack_public_path__ + "img/tik_yes.42c3578c.png";